<template>
  <svg-icon
    v-tooltip.top="props.tooltip"
    type="mdi"
    :path="mdiInformationOutline"
    class="info-icon"
  ></svg-icon>
</template>

<script setup>
import { defineProps } from "vue";
import { mdiInformationOutline } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

const props = defineProps({ tooltip: { type: String, default: "" } });
</script>

<style scoped></style>
